import { render, staticRenderFns } from "./Dish.vue?vue&type=template&id=f2f9f7f0&"
import script from "./Dish.vue?vue&type=script&lang=js&"
export * from "./Dish.vue?vue&type=script&lang=js&"
import style0 from "./Dish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports